import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL || '';

export default function Register() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [username, setUsername] = useState('');
  const [verifyCode, setVerifyCode] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPwd, setConfirmPwd] = useState('');
  const [realname, setRealname] = useState('');
  const [loading, setLoading] = useState(false);
  const [sending, setSending] = useState(false);
  const [message, setMessage] = useState('');
  const [countdown, setCountdown] = useState(0);

  const sendVerifyCode = async () => {
    if (!username) return setMessage('请输入账号');
    if (username.length < 2) return setMessage('账号至少2个字符');
    setSending(true);
    setMessage('');
    try {
      const res = await fetch(`${API_URL}/api/auth/code`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, type: 'register' })
      });
      const data = await res.json();
      if (data.success) {
        setMessage('验证码已发送到飞书');
        setStep(2);
        setCountdown(60);
        const timer = setInterval(() => {
          setCountdown(c => { if (c <= 1) { clearInterval(timer); return 0; } return c - 1; });
        }, 1000);
      } else {
        setMessage(data.error || '发送失败');
      }
    } catch (e) { setMessage('网络错误'); }
    setSending(false);
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    if (!verifyCode || !password) return setMessage('请填写完整信息');
    if (password !== confirmPwd) return setMessage('两次密码不一致');
    if (password.length < 4) return setMessage('密码至少4个字符');
    setLoading(true);
    setMessage('');
    try {
      const res = await fetch(`${API_URL}/api/auth/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password, verifyCode, realname })
      });
      const data = await res.json();
      if (data.success) {
        setMessage('注册成功！');
        setTimeout(() => navigate('/login'), 1500);
      } else {
        setMessage(data.error || '注册失败');
      }
    } catch (e) { setMessage('网络错误'); }
    setLoading(false);
  };

  return (
    <div className="login-page">
      <div className="login-box">
        <h2 className="login-title">📝 注册账号</h2>

        {step === 1 && (
          <div className="register-step">
            <input
              type="text"
              placeholder="请输入账号（至少2个字符）"
              value={username}
              onChange={e => setUsername(e.target.value)}
              className="login-input"
            />
            <button
              onClick={sendVerifyCode}
              disabled={sending}
              className="btn-login"
            >
              {sending ? '发送中...' : '发送验证码'}
            </button>
            {message && <p className="login-message">{message}</p>}
            <p className="login-tip">💡 验证码将发送到您的飞书</p>
          </div>
        )}

        {step === 2 && (
          <form onSubmit={handleRegister}>
            <input
              type="text"
              placeholder="验证码"
              value={verifyCode}
              onChange={e => setVerifyCode(e.target.value)}
              className="login-input"
              maxLength={6}
            />
            <input
              type="password"
              placeholder="设置密码（至少4个字符）"
              value={password}
              onChange={e => setPassword(e.target.value)}
              className="login-input"
            />
            <input
              type="password"
              placeholder="确认密码"
              value={confirmPwd}
              onChange={e => setConfirmPwd(e.target.value)}
              className="login-input"
            />
            <input
              type="text"
              placeholder="姓名（选填）"
              value={realname}
              onChange={e => setRealname(e.target.value)}
              className="login-input"
            />
            <button type="submit" disabled={loading} className="btn-login">
              {loading ? '注册中...' : '完成注册'}
            </button>
            {message && <p className="login-message">{message}</p>}
            <button
              type="button"
              onClick={() => { if (countdown === 0) sendVerifyCode(); }}
              disabled={countdown > 0}
              className="btn-resend"
            >
              {countdown > 0 ? `重新发送(${countdown}s)` : '重新发送验证码'}
            </button>
          </form>
        )}

        <p className="register-link">
          已有账号？ <span onClick={() => navigate('/login')}>立即登录</span>
        </p>
      </div>
    </div>
  );
}
